<template>
    <div
        class="vertical-slider"
        ref="slider"
    >
        <div
            class="slider-group"
            ref="sliderGroup"
        >
            <slot></slot>
        </div>
    </div>
</template>
 
<script>
import { addClass } from '../util/common';

export default {
    data() {
        return {};
    },
    props: {
        /**
         * 列表的数据
         */
        data: {
            type: Array,
            default: null
        },
        sum: {
            type: Number,
            default: 1
        }
    },
    mounted() {
        this.refresh();
        window.addEventListener('resize', () => {
            this.refresh();
        });
    },
    activated() {},
    deactivated() {},
    beforeDestroy() {},
    methods: {
        refresh() {
            this._setSlideWidth();
        },
        _setSlideWidth() {
            if (this.$refs && this.$refs.sliderGroup) {
                this.children = this.$refs.sliderGroup ? this.$refs.sliderGroup.children : [];
                let width = 0;
                let slideWidth = 0;
                this.$refs.slider && this.$refs.slider.clientWidth && (slideWidth = this.$refs.slider.clientWidth / this.sum);
                console.log(this.children.length, '9999999');
                for (let i = 0; i < this.children.length; i++) {
                    const child = this.children[i];
                    addClass(child, 'slider-item');
                    child.style.width = slideWidth + 'px';
                    width += slideWidth;
                }
                console.log(width, 'widthwidth');
                this.$refs.sliderGroup && (this.$refs.sliderGroup.style.width = width + 'px');
            }
        }
    },
    watch: {
        data() {
            this.refresh();
        }
    },
    destroyed() {
        this.$refs = null;
    }
};
</script>
<style lang="scss" scoped>
.vertical-slider {
    position: relative;
    width: 100%;
    height: auto;
    overflow: hidden;

    .slider-group {
        position: relative;
        white-space: nowrap;
        width: 100% !important;
        overflow-y: hidden;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        // padding-bottom: 20px;

        &::-webkit-scrollbar {
            display: none !important;
            width: 0 !important;
        }
    }

    .slider-item {
        display: inline-block;
        box-sizing: border-box;
        overflow: hidden;
        text-align: center;
    }
    .slider-item a {
        display: block;
        width: 100%;
        overflow: hidden;
        text-decoration: none;
    }
    .slider-item img {
        display: block;
        width: 100%;
    }
}
</style>
